<div class="page-content-with-right-sidebar ontario-row ontario-margin-top-0-!">
  <div class="main-content page-content ontario-row">
    @if (!isWorkerPortal) {
      <h1 id="train-elig-title">{{'Tab.EligibilityChecker' | translate}}</h1>
    }
    @if (!isWorkerPortal) {
      <div class="sub-heading-text">{{'TrainingEligibility.AccessYourTrainingRecords' | translate}}</div>
    }
    <div class="desktop-view">
      <app-tabs [clickable]="false">
        <app-tab [hasVerticalDivider]="true" [title]="'TrainingEligibility.EnterPersonalDetails' | translate">
          <form [formGroup]="formStep1">
            <div class="ontario-row">
              <div class="training-details">
                <div class="table-header">
                  <h2>{{'TrainingEligibility.EnterPersonalDetails' | translate}}</h2>
                  <hr class="inset">
                  <div class="ontario-padding-top-8-!">{{'General.MandatoryFields' | translate}}</div>
                  <div class="training-details-row">
                    <app-horizontal-radio-button-list  [label]="('TrainingEligibility.EnterNameOrMls' | translate) + '*'"
                      [currentLang]="currentLang" [radioButtonOptions]="identificationOptions"
                      (valueChange)="setIdentificationOption($event)" [(value)]="identificationOption">
                    </app-horizontal-radio-button-list>
                  </div>
                  <div class="training-details-row ontario-small-12 ontario-medium-6 ontario-large-4">
                    @if (identificationOption === 'id') {
                      <input required type="text" class='input-text' matInput
                        [class.disabled]="isWorkerPortal" [readonly]="isWorkerPortal"
                        (keyup)="showNotFoundBanner = false" formControlName="learnerID" [attr.aria-label]="currentLang === 'fr' ? 'ID d’apprenant' : 'Learner ID'"
                        placeholder="{{'TrainingEligibility.LearnerIdTooltip' | translate}}" />
                    }
                    @if (identificationOption === 'name') {
                      <input autocomplete="name" required type="text" class='input-text' matInput
                        [class.disabled]="isWorkerPortal" [readonly]="isWorkerPortal"
                        (keyup)="showNotFoundBanner = false" formControlName="learnerName" [attr.aria-label]="currentLang === 'fr' ? 'Nom de l’apprenant' : 'Learner name'"
                        placeholder="{{'TrainingEligibility.NameTooltip' | translate}}" />
                    }
                  </div>

                  @if (identificationOption === 'id' && formStep1.controls['learnerID'].invalid &&  formStep1.controls['learnerID'].errors && (formStep1.controls['learnerID'].dirty || formStep1.controls['learnerID'].touched)) {
                    <div role="alert">
                      @if (formStep1.controls['learnerID'].hasError('required')) {
                        <mat-error class="matErrorLearnerID">
                          {{'TrainingEligibility.Validation.LearnerID.Required' | translate}}
                        </mat-error>
                      }
                      @if (formStep1.controls['learnerID'].hasError('maxlength')) {
                        <mat-error class="matErrorLearnerID">
                          {{'TrainingEligibility.Validation.LearnerID.MaxLength' | translate}}
                        </mat-error>
                      }
                      @if (formStep1.controls['learnerID'].hasError('pattern')) {
                        <mat-error class="matErrorLearnerID">
                          {{'TrainingEligibility.Validation.LearnerID.Pattern' | translate}}
                        </mat-error>
                      }
                    </div>
                  }

                  @if (identificationOption === 'name' && formStep1.controls['learnerName'].invalid &&  formStep1.controls['learnerName'].errors && (formStep1.controls['learnerName'].dirty || formStep1.controls['learnerName'].touched)) {
                    <div role="alert">
                      @if (formStep1.controls['learnerName'].hasError('required')) {
                        <mat-error class="matErrorLearnerName">
                          {{'TrainingEligibility.Validation.LearnerName.Required' | translate}}
                        </mat-error>
                      }
                      @if (formStep1.controls['learnerName'].hasError('maxlength')) {
                        <mat-error class="matErrorLearnerName"
                          >
                          {{'TrainingEligibility.Validation.LearnerName.MaxLength' | translate}}
                        </mat-error>
                      }
                    </div>
                  }

                  <div class="training-details-row margined-top">
                    <app-horizontal-radio-button-list  [label]="('TrainingEligibility.EnterEmailPhonePostal' | translate) + '*'"
                      [currentLang]="currentLang" [radioButtonOptions]="contactOptions"
                      (valueChange)="setContactOption($event)" [(value)]="contactOption">
                    </app-horizontal-radio-button-list>
                  </div>

                  <div class="training-details-row ontario-small-12 ontario-medium-6 ontario-large-4">
                    @if (contactOption === 'email') {
                      <input autocomplete="email" required type="text" class='input-text' matInput [class.disabled]="isWorkerPortal" [readonly]="isWorkerPortal"
                        (keyup)="showNotFoundBanner = false" formControlName="emailID" [attr.aria-label]="currentLang === 'fr' ? 'Adresse courriel' : 'Email address'"
                        placeholder="{{'TrainingEligibility.EmailTooltip' | translate}}" />
                    }
                    @if (contactOption === 'phone') {
                      <input autocomplete="tel" required type='tel' class='input-text' mask="000-000-0000" matInput
                        [class.disabled]="isWorkerPortal" [readonly]="isWorkerPortal"
                        (keyup)="showNotFoundBanner = false" formControlName="phoneNo" [attr.aria-label]="currentLang === 'fr' ? 'Numéro de téléphone' : 'Phone number'"
                        placeholder="{{'TrainingEligibility.PhoneTooltip' | translate}}" />
                    }
                    @if (contactOption === 'postal') {
                      <input autocomplete="postal-code" required type="text" class='input-text' matInput
                        [class.disabled]="isWorkerPortal" [readonly]="isWorkerPortal"
                        (keyup)="showNotFoundBanner = false" formControlName="postalCode" [attr.aria-label]="currentLang === 'fr' ? 'Code postal' : 'Postal code'"
                        placeholder="{{'TrainingEligibility.PostalTooltip' | translate}}" />
                    }
                  </div>

                  @if (contactOption === 'email' && formStep1.controls['emailID'].invalid &&  formStep1.controls['emailID'].errors &&
                    (formStep1.controls['emailID'].dirty || formStep1.controls['emailID'].touched)) {
                    <div role="alert">
                      @if (formStep1.controls['emailID'].hasError('required')) {
                        <mat-error class="matErrorEmail">
                          {{'Validation.Email.Required' | translate}}
                        </mat-error>
                      }
                      @if (formStep1.controls['emailID'].hasError('email')) {
                        <mat-error class="matErrorEmail">
                          {{'Validation.Email.Pattern' | translate}}
                        </mat-error>
                      }
                    </div>
                  }

                  @if (contactOption === 'phone' && formStep1.controls['phoneNo'].invalid &&  formStep1.controls['phoneNo'].errors &&
                    (formStep1.controls['phoneNo'].dirty || formStep1.controls['phoneNo'].touched)) {
                    <div role="alert">
                      @if (formStep1.controls['phoneNo'].hasError('required')) {
                        <mat-error class="matErrorPhone">
                          {{'Validation.Phone.Required' | translate}}
                        </mat-error>
                      }
                      @if (formStep1.controls['phoneNo'].hasError('pattern')) {
                        <mat-error class="matErrorPhone">
                          {{'Validation.Phone.Pattern' | translate}}
                        </mat-error>
                      }
                    </div>
                  }

                  @if (contactOption === 'postal' && formStep1.controls['postalCode'].invalid &&  formStep1.controls['postalCode'].errors &&
                    (formStep1.controls['postalCode'].dirty || formStep1.controls['postalCode'].touched)) {
                    <div role="alert">
                      @if (formStep1.controls['postalCode'].hasError('required')) {
                        <mat-error class="matErrorPostal">
                          {{'Validation.PostalCode.Required' | translate}}
                        </mat-error>
                      }
                      @if (formStep1.controls['postalCode'].hasError('pattern')) {
                        <mat-error class="matErrorPostal">
                          {{'Validation.PostalCode.Pattern' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>

                <div class="training-details-row ontario-row buttons-container">
                  @if (showNotFoundBanner) {
                    <app-alert-banner bannerType="error" [bannerText]="'Error.WeCouldNotFindRecords' | translate">
                    </app-alert-banner>
                  }
                  <button class="ontario-button" [disabled]="!formStep1.valid" id="submit-step1-button" (click)="SelectStep(1);" type="submit">
                    {{'TrainingEligibility.Step2' | translate}}
                  </button>
                  <button id="reset-button-step1" (click)="resetStep1()" class="ontario-button ontario-button--tertiary">
                    {{'General.Reset' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </app-tab>

        <app-tab [title]="'TrainingEligibility.CheckEligibility' | translate">
          <form [formGroup]="formStep2" (ngSubmit)="checkEligibility()">
            <div class="ontario-row">
              <div class="training-details">
                <h2>{{'TrainingEligibility.CheckEligibility' | translate}}</h2>
                <hr class="inset">
                @if (this._checkEligibility == null || this._checkEligibility == undefined) {
                  <div>
                    <div class="training-details-row form-input-div ontario-small-10 ontario-medium-6 ontario-large-4">
                      <app-dropdown [label]="'TrainingEligibility.CheckEligibilityFor' | translate"
                        [placeholder]="'TrainingEligibility.SelectACourse' | translate" [currentLang]="currentLang"
                      [options]="trainingProgramOptions" [(formValue)]="trainingProgramOptionValue"></app-dropdown>
                    </div>
                    <div class="training-details-row form-input-div ontario-small-12 ontario-medium-6 ontario-large-4 margined-top">
                      <label for="eligibilityOnDate">
                        {{ 'TrainingEligibility.EligibilityOn' | translate }}
                      </label>
                      <input type="date" name="eligibilityOnDate" id="eligibilityOnDate" class="ontario-input start-date"
                        formControlName="eligibilityOnDate" [min]="today" />
                      </div>
                      @if (formStep2.controls['eligibilityOnDate'].invalid &&  formStep2.controls['eligibilityOnDate'].errors &&
                        (formStep2.controls['eligibilityOnDate'].dirty || formStep2.controls['eligibilityOnDate'].touched)) {
                        <div role="alert">
                          @if (formStep2.controls['eligibilityOnDate'].hasError('required')) {
                            <mat-error class="matErrorPostal">
                              {{'TrainingEligibility.Validation.EligibilityOnDate.Required' | translate}}
                            </mat-error>
                          }
                          @if (formStep2.controls['eligibilityOnDate'].hasError('minDate')) {
                            <mat-error class="matErrorPostal">
                              {{'TrainingEligibility.Validation.EligibilityOnDate.MustBeCurrentOrFuture' | translate}}
                            </mat-error>
                          }
                        </div>
                      }
                    </div>
                    <div class="training-details-row buttons-container ontario-row">
                      <button class="ontario-button" id="submit-step2-button" [disabled]="!formStep2.valid || trainingProgramOptionValue == ''" type="submit">
                        {{'TrainingEligibility.CheckEligibility' | translate}}
                      </button>
                      <button class="ontario-button" id="go-back-button" (click)=" SelectStep(0);" type="button">
                        {{'General.Back' | translate}}
                      </button>
                      <button id="reset-button-step2" (click)="resetStep2()" class="ontario-button ontario-button--tertiary" type="button">
                        {{'General.Reset' | translate}}
                      </button>
                    </div>
                  }
                </div>
              </div>
            </form>
          </app-tab>
        </app-tabs>
      </div>
      @if (this._checkEligibility == null || this._checkEligibility == undefined) {
        <div class="mobile-view">
          <form [formGroup]="formStep1" (click)="status=1" >
            <div class="ontario-row">
              <ng-container>
                <div class="training-details">
                  <div class="table-header ontario-margin-top-24-!">
                    <div class="bg-color" [class.active]="status==1">
                      <span [ngClass]="status==1 ?'counter-blue':'counter'">1</span>
                      <span class="learner-details"  [class.active]="status==1">{{'TrainingEligibility.EnterPersonalDetails' | translate}}</span>
                    </div>
                    <div class="training-details-row">
                      <app-horizontal-radio-button-list class="personal-dets" [label]="'TrainingEligibility.EnterNameOrMls' | translate"
                        [currentLang]="currentLang" [radioButtonOptions]="identificationOptions"
                        (valueChange)="setIdentificationOption($event)" [(value)]="identificationOption">
                      </app-horizontal-radio-button-list>
                    </div>
                    <div class="training-details-row ontario-small-12 ontario-medium-6 ontario-large-4">
                      @if (identificationOption === 'id') {
                        <input type="text" class='input-text' matInput
                          [class.disabled]="isWorkerPortal" [readonly]="isWorkerPortal"
                          (keyup)="showNotFoundBanner = false" formControlName="learnerID" [attr.aria-label]="currentLang === 'fr' ? 'ID d’apprenant' : 'Learner ID'"
                          placeholder="{{'TrainingEligibility.LearnerIdTooltip' | translate}}" />
                      }
                      @if (identificationOption === 'name') {
                        <input type="text" class='input-text' matInput
                          [class.disabled]="isWorkerPortal" [readonly]="isWorkerPortal"
                          (keyup)="showNotFoundBanner = false" formControlName="learnerName" [attr.aria-label]="currentLang === 'fr' ? 'Nom de l’apprenant' : 'Learner name'"
                          placeholder="{{'TrainingEligibility.NameTooltip' | translate}}" />
                      }
                    </div>
                    @if (identificationOption === 'id' && formStep1.controls['learnerID'].invalid &&  formStep1.controls['learnerID'].errors && (formStep1.controls['learnerID'].dirty || formStep1.controls['learnerID'].touched)) {
                      <div role="alert">
                        @if (formStep1.controls['learnerID'].hasError('required')) {
                          <mat-error class="matErrorLearnerID">
                            {{'TrainingEligibility.Validation.LearnerID.Required' | translate}}
                          </mat-error>
                        }
                        @if (formStep1.controls['learnerID'].hasError('maxlength')) {
                          <mat-error class="matErrorLearnerID">
                            {{'TrainingEligibility.Validation.LearnerID.MaxLength' | translate}}
                          </mat-error>
                        }
                        @if (formStep1.controls['learnerID'].hasError('pattern')) {
                          <mat-error class="matErrorLearnerID">
                            {{'TrainingEligibility.Validation.LearnerID.Pattern' | translate}}
                          </mat-error>
                        }
                      </div>
                    }
                    @if (identificationOption === 'name' && formStep1.controls['learnerName'].invalid &&  formStep1.controls['learnerName'].errors && (formStep1.controls['learnerName'].dirty || formStep1.controls['learnerName'].touched)) {
                      <div role="alert">
                        @if (formStep1.controls['learnerName'].hasError('required')) {
                          <mat-error class="matErrorLearnerName">
                            {{'TrainingEligibility.Validation.LearnerName.Required' | translate}}
                          </mat-error>
                        }
                        @if (formStep1.controls['learnerName'].hasError('maxlength')) {
                          <mat-error class="matErrorLearnerName"
                            >
                            {{'TrainingEligibility.Validation.LearnerName.MaxLength' | translate}}
                          </mat-error>
                        }
                      </div>
                    }
                    <div class="training-details-row margined-top">
                      <app-horizontal-radio-button-list [label]="'TrainingEligibility.EnterEmailPhonePostal' | translate"
                        [currentLang]="currentLang" [radioButtonOptions]="contactOptions"
                        (valueChange)="setContactOption($event)" [(value)]="contactOption">
                      </app-horizontal-radio-button-list>
                    </div>
                    <div class="training-details-row ontario-small-12 ontario-medium-6 ontario-large-4">
                      @if (contactOption === 'email') {
                        <input type="text" class='input-text' matInput [class.disabled]="isWorkerPortal" [readonly]="isWorkerPortal"
                          (keyup)="showNotFoundBanner = false" formControlName="emailID" [attr.aria-label]="currentLang === 'fr' ? 'Adresse courriel' : 'Email address'"
                          placeholder="{{'TrainingEligibility.EmailTooltip' | translate}}" />
                      }
                      @if (contactOption === 'phone') {
                        <input type='tel' class='input-text' mask="000-000-0000" matInput
                          [class.disabled]="isWorkerPortal" [readonly]="isWorkerPortal"
                          (keyup)="showNotFoundBanner = false" formControlName="phoneNo" [attr.aria-label]="currentLang === 'fr' ? 'Numéro de téléphone' : 'Phone number'"
                          placeholder="{{'TrainingEligibility.PhoneTooltip' | translate}}" />
                      }
                      @if (contactOption === 'postal') {
                        <input type="text" class='input-text' matInput
                          [class.disabled]="isWorkerPortal" [readonly]="isWorkerPortal"
                          (keyup)="showNotFoundBanner = false" formControlName="postalCode" [attr.aria-label]="currentLang === 'fr' ? 'Code postal' : 'Postal code'"
                          placeholder="{{'TrainingEligibility.PostalTooltip' | translate}}" />
                      }
                    </div>
                    @if (contactOption === 'email' && formStep1.controls['emailID'].invalid &&  formStep1.controls['emailID'].errors &&
                      (formStep1.controls['emailID'].dirty || formStep1.controls['emailID'].touched)) {
                      <div role="alert">
                        @if (formStep1.controls['emailID'].hasError('required')) {
                          <mat-error class="matErrorEmail">
                            {{'Validation.Email.Required' | translate}}
                          </mat-error>
                        }
                        @if (formStep1.controls['emailID'].hasError('email')) {
                          <mat-error class="matErrorEmail">
                            {{'Validation.Email.Pattern' | translate}}
                          </mat-error>
                        }
                      </div>
                    }
                    @if (contactOption === 'phone' && formStep1.controls['phoneNo'].invalid &&  formStep1.controls['phoneNo'].errors &&
                      (formStep1.controls['phoneNo'].dirty || formStep1.controls['phoneNo'].touched)) {
                      <div role="alert">
                        @if (formStep1.controls['phoneNo'].hasError('required')) {
                          <mat-error class="matErrorPhone">
                            {{'Validation.Phone.Required' | translate}}
                          </mat-error>
                        }
                        @if (formStep1.controls['phoneNo'].hasError('pattern')) {
                          <mat-error class="matErrorPhone">
                            {{'Validation.Phone.Pattern' | translate}}
                          </mat-error>
                        }
                      </div>
                    }
                    @if (contactOption === 'postal' && formStep1.controls['postalCode'].invalid &&  formStep1.controls['postalCode'].errors &&
                      (formStep1.controls['postalCode'].dirty || formStep1.controls['postalCode'].touched)) {
                      <div role="alert">
                        @if (formStep1.controls['postalCode'].hasError('required')) {
                          <mat-error class="matErrorPostal">
                            {{'Validation.PostalCode.Required' | translate}}
                          </mat-error>
                        }
                        @if (formStep1.controls['postalCode'].hasError('pattern')) {
                          <mat-error class="matErrorPostal">
                            {{'Validation.PostalCode.Pattern' | translate}}
                          </mat-error>
                        }
                      </div>
                    }
                  </div>
                  <!-- <div class="training-details-row ontario-row buttons-container">
                  <app-alert-banner *ngIf="showNotFoundBanner" bannerType="error" [bannerText]="'Error.WeCouldNotFindRecords' | translate">
                  </app-alert-banner>
                </div> -->
              </div>
            </ng-container>
          </div>
        </form>
        <form [formGroup]="formStep2" (click)="status=2">
          <div class="ontario-row">
            <div class="training-details">
              <div class="table-header ontario-margin-top-24-!">
                @if (this._checkEligibility == null || this._checkEligibility == undefined) {
                  <div class="bg-color" [class.active]="status==2">
                    <span [ngClass]="status==2 ?'counter-blue':'counter'">2</span>
                    <span class="learner-details" [class.active]="status==2">{{'TrainingEligibility.CheckEligibility' | translate}}</span>
                  </div>
                  <div>
                    <div class="training-details-row form-input-div ontario-small-10 ontario-medium-6 ontario-large-4">
                      <app-dropdown [label]="'TrainingEligibility.CheckEligibilityFor' | translate"
                        [placeholder]="'TrainingEligibility.SelectACourse' | translate" [currentLang]="currentLang"
                      [options]="trainingProgramOptions" [(formValue)]="trainingProgramOptionValue"></app-dropdown>
                    </div>
                    <div class="training-details-row form-input-div ontario-small-12 ontario-medium-6 ontario-large-4 margined-top">
                      <label for="eligibilityOnDateMobile">
                        {{ 'TrainingEligibility.EligibilityOn' | translate }}
                      </label>
                      <input type="date" name="eligibilityOnDateMobile" id="eligibilityOnDateMobile" class="ontario-input start-date"
                        formControlName="eligibilityOnDate" [min]="today" />
                      </div>
                      @if (formStep2.controls['eligibilityOnDate'].invalid &&  formStep2.controls['eligibilityOnDate'].errors &&
                        (formStep2.controls['eligibilityOnDate'].dirty || formStep2.controls['eligibilityOnDate'].touched)) {
                        <div role="alert">
                          @if (formStep2.controls['eligibilityOnDate'].hasError('required')) {
                            <mat-error class="matErrorPostal">
                              {{'TrainingEligibility.Validation.EligibilityOnDate.Required' | translate}}
                            </mat-error>
                          }
                          @if (formStep2.controls['eligibilityOnDate'].hasError('minDate')) {
                            <mat-error class="matErrorPostal">
                              {{'TrainingEligibility.Validation.EligibilityOnDate.MustBeCurrentOrFuture' | translate}}
                            </mat-error>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </form>
          @if (this._checkEligibility == null || this._checkEligibility == undefined) {
            <div class="fixed-bottom">
              <div class="menu-div menu-div-left">
                <span>
                  <a [routerLink]="backToHome()">{{this.translateService.instant('Worker.Home')}}</a>
                </span>
              </div>
              <div class="menu-div menu-div-right">
                <span type="submit" (click)="checkEligibility()" [class.disabled]="!formStep2.valid || trainingProgramOptionValue == ''">
                  {{'TrainingEligibility.CheckEligibility' | translate}}
                </span>
              </div>
            </div>
          }
        </div>
      }

      @if (_checkEligibility != null) {
        <app-training-eligibility-result [currentLang]="currentLang" [identificationOption]="identificationOption" [contactOption]="contactOption"
          [trainingEligibilityForm]="trainingEligibilityForm" [checkEligibility]="_checkEligibility">
        </app-training-eligibility-result>
        <div class="mobile-view">
          <div class="border">
          </div>
          <div class="ontario-small-8">
            <button class="ontario-button grey-button courses-button" (click)=" backToMarketplace();" type="button">
              {{'TrainingEligibility.FindCPOApprovedCourses' | translate}}
            </button>
          </div>
          <div class="fixed-bottom">
            <div class="menu-div menu-div-left">
              <span>
                <a [routerLink]="backToHome()">{{this.translateService.instant('Worker.Home')}}</a>
              </span>
            </div>
            <div class="menu-div menu-div-right">
              <span type="submit" (click)=" SelectStep(0);" >
                {{'TrainingEligibility.CheckAgain' | translate}}
              </span>
            </div>
          </div>
        </div>
        <div class=" desktop-view buttons-container ontario-row">
          <button class="ontario-button" id="check-again-button" (click)=" SelectStep(0);" type="button">
            {{'TrainingEligibility.CheckAgain' | translate}}
          </button>
          @if (_checkEligibility.IsEligible && _checkEligibility.RequestedTrainingName.indexOf('JHSC')>=0) {
            <button class="ontario-button black-button" id="navigate-button" type="button" (click)=" backToMarketplace();">
              {{'TrainingEligibility.ExploreJHSCTrainingOfferings' | translate}}
            </button>
          }
          @if (_checkEligibility.IsEligible && _checkEligibility.RequestedTrainingName.indexOf('JHSC')<0) {
            <button class="ontario-button black-button" id="navigate-button" type="button" (click)=" backToMarketplace();">
              {{'TrainingEligibility.ExploreWAHTrainingOfferings' | translate}}
            </button>
          }
        </div>
      }
    </div>
    @if (!isWorkerPortal) {
      <div class="right-sidebar">
        <app-page-content-loop [pageContents]="trainingEligibilitySideBarContents"></app-page-content-loop>
      </div>
    }
  </div>


